import Passenger from '@/components/Passenger/models/Passenger';
import { IEntityMapping, IPropertyMapping } from '@/typings/import';

export default class PassengerMapping implements IEntityMapping<Passenger> {
  static readonly UTILITY_KEY = 'utility';
  static readonly PROPERTY_MAPPING_UTILITIES = 'utilities';
  static readonly PROPERTY_MAPPING_DESTINATION = 'destination';
  static readonly PROPERTY_MAPPING_SECONDARY_DESTINATION = 'secondaryDestination';
  static readonly PROPERTY_MAPPING_SSN = 'ssn';

  name: IPropertyMapping = {
    propertyName: 'name',
    propertyType: 'string',
    required: true,
    static: null,
    cell: null,
    allowStatic: false,
    useStatic: false
  };
  externalId: IPropertyMapping = {
    propertyName: 'externalId',
    propertyType: 'string',
    required: false,
    static: null,
    cell: null,
    allowStatic: false,
    useStatic: false
  };
  ssn: IPropertyMapping = {
    propertyName: 'ssn',
    propertyType: 'string',
    required: false,
    static: null,
    cell: null,
    allowStatic: false,
    useStatic: false
  };
  destination: IPropertyMapping = {
    propertyName: 'destination',
    propertyType: 'string',
    required: false,
    static: null,
    cell: null,
    allowStatic: true,
    useStatic: false
  };
  secondaryDestination: IPropertyMapping = {
    propertyName: 'secondaryDestination',
    propertyType: 'string',
    required: false,
    static: null,
    cell: null,
    allowStatic: true,
    useStatic: false
  };
  homeAddress: IPropertyMapping = {
    propertyName: 'homeAddress',
    propertyType: 'string',
    required: false,
    static: null,
    cell: null,
    allowStatic: false,
    useStatic: false
  };
  homeCity: IPropertyMapping = {
    propertyName: 'homeCity',
    propertyType: 'string',
    required: false,
    static: null,
    cell: null,
    allowStatic: false,
    useStatic: false
  };
  homePostalcode: IPropertyMapping = {
    propertyName: 'homePostalcode',
    propertyType: 'string',
    required: false,
    static: null,
    cell: null,
    allowStatic: false,
    useStatic: false
  };
  pickupAddress: IPropertyMapping = {
    propertyName: 'pickupAddress',
    propertyType: 'string',
    required: false,
    static: null,
    cell: null,
    allowStatic: false,
    useStatic: false,
  };
  billingUseHomeAddress: IPropertyMapping = {
    propertyName: 'billingUseHomeAddress',
    propertyType: 'boolean',
    required: false,
    static: 'true',
    cell: null,
    allowStatic: true,
    useStatic: true
  };
  billingAddress: IPropertyMapping = {
    propertyName: 'billingAddress',
    propertyType: 'string | null',
    required: false,
    static: null,
    cell: null,
    allowStatic: false,
    useStatic: false
  };
  billingPostalcode: IPropertyMapping = {
    propertyName: 'billingAddress',
    propertyType: 'string | null',
    required: false,
    static: null,
    cell: null,
    allowStatic: false,
    useStatic: false
  };
  billingCity: IPropertyMapping = {
    propertyName: 'billingAddress',
    propertyType: 'string | null',
    required: false,
    static: null,
    cell: null,
    allowStatic: false,
    useStatic: false
  };
  yearGrade: IPropertyMapping = {
    propertyName: 'yearGrade',
    propertyType: 'number',
    required: false,
    static: null,
    cell: null,
    allowStatic: true,
    useStatic: false
  };
  note: IPropertyMapping = {
    propertyName: 'note',
    propertyType: 'string',
    required: false,
    static: null,
    cell: null,
    allowStatic: true,
    useStatic: false
  };
  timitNote: IPropertyMapping = {
    propertyName: 'timitNote',
    propertyType: 'string',
    required: false,
    static: null,
    cell: null,
    allowStatic: true,
    useStatic: false
  };
  language: IPropertyMapping = {
    propertyName: 'language',
    propertyType: 'string',
    required: false,
    static: null,
    cell: null,
    allowStatic: true,
    useStatic: false
  };
  groups: IPropertyMapping = {
    propertyName: 'groups',
    propertyType: 'string',
    required: false,
    static: null,
    cell: null,
    allowStatic: true,
    useStatic: false
  };

  constructor(mapping?: IEntityMapping<Passenger>) {
    if (mapping) {
      Object.keys(mapping).forEach(k => this[k] = mapping[k]);
    }

    if (!this.props.some(p => p && p.propertyName && p.propertyName.includes(PassengerMapping.UTILITY_KEY))) {
      Passenger.utilities.forEach(u => {
        const name = `${PassengerMapping.UTILITY_KEY}-${u.id}`;
        this[name] = {
          propertyName: `${name}`,
          propertyType: 'string',
          required: false,
          allowStatic: false,
          useStatic: false
        };
      });
    }
  }

  get props(): IPropertyMapping[] {
    return Object.keys(this).map(k => this[k]);
  }

  isValid(): boolean {
    return true;
  }

  updateSearchProperty(searchProperty: IPropertyMapping) {
    let updatedProperty: IPropertyMapping | null = null;
    switch (searchProperty.propertyName) {
      case 'name':
        updatedProperty = this.name;
        break;
      case 'externalId':
        updatedProperty = this.externalId;
        break;
      case 'ssn':
        updatedProperty = this.ssn;
        break;
    }
    if (!updatedProperty) {
      return;
    }

    updatedProperty.cell = searchProperty.cell;
    updatedProperty.static = searchProperty.static;
    updatedProperty.useStatic = searchProperty.useStatic;
  }
}
